import clsx from "clsx";
import Table from "react-bootstrap/Table";
import { Form, FormControl, FormGroup } from "react-bootstrap";
import { React, useEffect, useState } from "react";
import _ from "lodash";
import * as setOffSelectors from "../../../../../selectors/set-off";
import CustomPriceSpan from "../../../../../components/CustomPriceSpan";
import CurrencyInput from "react-currency-input-field";
import * as userSelectors from "../../../../../selectors/user";
import {
  getSetOffAccrueInterestFullText,
  getSetOffTotalOutstandingAmountFullText,
  getSetOffTotalOutstandingBalance,
  getSetOffTotalOutstandingBalanceFullText,
} from "../../../../../selectors/set-off";
import * as depositSelectors from "../../../../../selectors/e-deposit";

const paymentMethods = [
  { label: "FPX Online Transfer", value: "fpx" },
  { label: "Manual Transfer", value: "manual" },
];

function PaymentHistoryTable({
  selectedCurrency,
  handleContinue,
  handleGoBack,
  data,
  total,
  totalAmount,
  paymentConfig,
}) {
  const selectedCurrencyKey = userSelectors.getUserAccountKey(selectedCurrency);
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    const onlinePayment = _.get(paymentConfig, ["online_payment", "supported_currencies"], []);
    const manualPayment = _.get(paymentConfig, ["manual_payment", "supported_currencies"], []);

    if (_.some(onlinePayment, _.matchesProperty("value", selectedCurrencyKey))) {
      setSelectedOption("fpx");
    } else if (_.some(manualPayment, _.matchesProperty("value", selectedCurrencyKey))) {
      setSelectedOption("manual");
    }
  }, [paymentConfig]);

  const onlinePaymentCurrency = _.get(paymentConfig, ["online_payment", "supported_currencies"], []);
  const manualPaymentCurrency = _.get(paymentConfig, ["manual_payment", "supported_currencies"], []);
  return (
    <div className={clsx("custom-table-info-container padding-12px")}>
      <div className={"responsive-table-border table-w-1400"}>
        <Table responsive="lg" className="table">
          <thead>
            <tr className={"custom-table-setoff-styled"}>
              {/*===== For "CheckBox" ===== */}
              <th style={{ minWidth: 100 }}>Ref No</th>
              <th style={{ minWidth: 80 }}>Date</th>
              <th style={{ minWidth: 60 }}>Counter</th>
              <th style={{ minWidth: 100 }}>Amount</th>
              <th style={{ minWidth: 120 }}>Accrued Interest</th>
              <th style={{ minWidth: 100 }}>Balance Amount</th>
              {/*===== End for For "CheckBox" ===== */}
              {/*===== For "Part Amt" ===== */}
              <th style={{ minWidth: "200px" }}>Payment Amount</th>
              {/*===== End for "Part Amt" ===== */}
            </tr>
          </thead>
          <tbody>
            {data &&
              _.map(data, (item, index) => {
                const subTotal = _.get(item, ["subTotal"]);
                const dataItem = _.get(item, ["data"]);
                const refNo = setOffSelectors.getSetOffContractReference(dataItem);
                const date = setOffSelectors.getSetOffTransactionDate(dataItem);
                const stockCode = setOffSelectors.getSetOffStockCode(dataItem);
                const stockName = setOffSelectors.getSetOffStockName(dataItem);
                const balAmount = setOffSelectors.getSetOffOutstandingAmountFullText(dataItem);
                const accrueInterest = setOffSelectors.getSetOffAccrueInterestFullText(dataItem);
                const total = setOffSelectors.getSetOffTotalOutstandingBalanceFullText(dataItem);

                return (
                  <tr key={index}>
                    <td>{refNo}</td>
                    <td>{date}</td>
                    <td>{stockCode}</td>
                    <td>{balAmount}</td>
                    <td>{accrueInterest}</td>
                    <td>{total}</td>
                    <td>
                      {selectedCurrency.text} <CustomPriceSpan value={subTotal}></CustomPriceSpan>
                    </td>
                  </tr>
                );
              })}
          </tbody>
          <tfoot className="setoff-table-footer">
            <tr>
              <th></th>
              <th>
                <div className="d-flex justify-content-end mr-3">Selected Amount</div>
              </th>
              {/*<th><div className="d-flex justify-content-between"><span>{totalPayment}</span></div></th>*/}
              <th>
                <div className="d-flex justify-content-between">
                  <span>
                    {selectedCurrency.text} <CustomPriceSpan value={total}></CustomPriceSpan>
                  </span>
                </div>
              </th>
              <th>
                <div className="d-flex justify-content-end mr-3">Deposit into Trust</div>
              </th>
              {/*<th><div className="d-flex justify-content-between"><span>{totalPayment}</span></div></th>*/}
              <th>
                <div className="d-flex ">
                  <span>
                    {selectedCurrency.text}{" "}
                    <CustomPriceSpan value={Number(totalAmount) - Number(total)}></CustomPriceSpan>
                  </span>
                </div>
              </th>
              <th>
                <div className="d-flex justify-content-end mr-3 text-bold-600">Total Payment Amount</div>
              </th>
              {/*<th><div className="d-flex justify-content-between"><span>{totalPayment}</span></div></th>*/}
              <th>
                <div className="d-flex text-bold-600">
                  <span>
                    {selectedCurrency.text} <CustomPriceSpan value={totalAmount}></CustomPriceSpan>
                  </span>
                </div>
              </th>
            </tr>
          </tfoot>
        </Table>
      </div>
      <div className="d-flex justify-content-center">
      <div className="d-flex justify-content-center text-center py-3 flex-md-row flex-column align-items-start">
        {paymentMethods.map((method) => {
          const currencyCheck =
            method.value === "fpx"
              ? onlinePaymentCurrency
              : method.value === "manual"
                ? manualPaymentCurrency
                : [];

          return (
            <div key={method.value} className="radio-label">
              <FormGroup>
                <Form.Check
                  id={`radio-${method.value}`}
                  inline
                  label={method.label}
                  name="paymentMethod"
                  type="radio"
                  className="radio-button-transaction"
                  value={method.value}
                  disabled={!_.some(currencyCheck, _.matchesProperty("value", selectedCurrencyKey))}
                  onChange={() => setSelectedOption(method.value)}
                  checked={selectedOption === method.value}
                />
                {!_.isEmpty(paymentConfig) &&
                selectedOption === method.value &&
                !_.some(
                  method.value === "fpx" ? onlinePaymentCurrency : manualPaymentCurrency,
                  _.matchesProperty("value", selectedCurrencyKey),
                ) ? (
                  <span className="form-check-error">*Currency is not supported.</span>
                ) : (
                  false
                )}
              </FormGroup>
            </div>
          );
        })}
      </div>
      </div>
      <div className="d-flex justify-content-center py-3">
        <button className={clsx("btn custom-button-back")} type="submit" onClick={handleGoBack}>
          Back
        </button>
        <button
          className={clsx("btn custom-button-primary")}
          type="submit"
          style={{ backgroundColor: "#9D7905" }}
          disabled={
            !_.some(
              selectedOption === "fpx" ? onlinePaymentCurrency : manualPaymentCurrency,
              _.matchesProperty("value", selectedCurrencyKey),
            )
          }
          onClick={() => handleContinue(selectedOption)}
        >
          Continue
        </button>
      </div>
      <div className="text-center py-3">
        <span className="warning-notice">*No Third Party Fund Transfer is allowed</span>
      </div>
    </div>
  );
}

export default PaymentHistoryTable;
